import { render, staticRenderFns } from "./FormGudangModal.vue?vue&type=template&id=36a93db5&"
import script from "./FormGudangModal.vue?vue&type=script&lang=js&"
export * from "./FormGudangModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports